import React from "react";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from "@chakra-ui/react";
import { Outlet, Link as RouterLink } from "react-router-dom";

export default function RentalsLayout({ title = "Rentals" }) {
  return (
    <Box p={4}>
      <Breadcrumb mb={3} fontSize="14px">
        <BreadcrumbItem>
          <BreadcrumbLink as={RouterLink} to="/rentals/assets">
            Rentals
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Outlet />
    </Box>
  );
}
